/** One card of the mocked supplies surface. Its own file, as the
 *  one-component-per-file rule has it. */
import { ScopeToggle } from './ScopeToggle';
import { EM_DASH, SKELETON_KEYS, WEEK_COLS, cardHeading } from './supplies-mock';

export function ProjectedInventoryCard() {
  return (
    <section
      className="nb-card"
      style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}
    >
      <div className="nb-card-hd">
        <div>
          <h3 className="nb-display" style={cardHeading}>
            Projected Inventory · 6 weeks
          </h3>
          <div style={{ fontSize: 11, color: 'var(--nb-subtle)', marginTop: 2 }}>
            after upcoming workshops &amp; resupplies
          </div>
        </div>
        <ScopeToggle />
      </div>
      <table className="nb-tbl" style={{ fontSize: 12 }}>
        <thead>
          <tr>
            <th style={{ minWidth: 160 }}>SKU</th>
            <th>Par</th>
            {WEEK_COLS.map((l) => (
              <th key={l} style={{ textAlign: 'right' }}>
                {l}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {SKELETON_KEYS.map((k) => (
            <tr key={k}>
              <td style={{ fontWeight: 600, color: 'var(--nb-subtle)' }}>{EM_DASH}</td>
              <td className="nb-tabular nb-mono nb-muted">{EM_DASH}</td>
              {WEEK_COLS.map((c) => (
                <td
                  key={c}
                  className="nb-tabular nb-mono"
                  style={{ textAlign: 'right', color: 'var(--nb-subtle)' }}
                >
                  {EM_DASH}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
